<template>
  <div class="pb-6 mx-8">
    <div class="w-full pb-4">
      <div>
        <a
          href="https://www.boingkids.co.uk/"
          target="_blank"
          class="hover:opacity-75"
        >
          <img src="/static/images/boing-bar.png" alt="" />
        </a>
      </div>

      <div>
        <h3 class="text-lg font-bold mb-2">
          Discovering the joy in physical activity, by developing physical
          literacy
        </h3>
      </div>
    </div>

              <div class="mb-5 pb-32" v-if="!hasBoingAccess">
          <p class="font-semibold">
                       Register your interest below to get further information
                        about our Boing Kids features and content,
                         including the new PlayTank games and activities.

          </p>

          <div class="flex  w-4/12  mt-6" v-if="!registerComplete">
            <button
              @click="registerInterest()"
              class="block bg-blue-500 bg-opacity-75 hover:bg-opacity-50 mr-4 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Register my interest
            </button>

            <button
              @click="registerSignUp()"
              class="block bg-orange-500 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Sign school up now!
            </button>
          </div>

          <p class="text-green-500 font-bold mt-2" v-else>
            Thank you for registering your interest. <br />One of our team will
            be in touch.
          </p>
        </div>

        <div v-else >
                    <p class="mb-2">
          Explore our new and improved PlayTank.
        </p>

            <div class="grid grid-cols-2 md:grid-cols-4 gap-8 mr-10 pb-32">
      <div
        class="w-full h-56 block cursor-pointer hover:opacity-75"
        v-for="data in stages"
        :key="data.id"
        @click="showContent(data)"
      >
        <div
          class="block w-full h-full"
          :title="data.title"
          :style="{ backgroundImage: 'url(' + contentImage(data) + ')' }"
          style="
            background-position: top left;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          "
        ></div>
      </div>
    </div>
        </div>

  <ModalSlide
        :show="showBoard"
        :headCss="'bg-opacity-25'"
        @closeModal="cancel()"
      >
      <template v-slot:header-icon>
        <i class="fas fa-bell"></i>
      </template>
        <template v-slot:header-title>
            <h2 class="text-xl font-bold">{{ typeTitle }}</h2>
        </template>
        <template v-slot:body>

            <p class="p-4" v-if="selectedType === 'signup'">Thank you for expressing an interest in signing up to our Boing Kids feature. <br/>
            Should you proceed, one of our team will be in touch and the Boing Kids feature will be activated within your account in the next 24 hours. <br/>
            A corresponding invoice will be sent to your school admin contact.</p>

            <p class="p-4" v-else>Thank you for expressing an interest in signing up to Boing Kids feature. <br/>
            Should you proceed, one of our team will be in touch to discuss details.</p>

            <div class="flex flex-wrap mx-3 mb-4">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Name
                </label>
                <input
                  v-model="contactName"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>
            <div class="flex flex-wrap mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Email
                </label>
                <input
                  v-model="contactEmail"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex mx-auto w-8/12 p-2 space-x-4 pb-4">
                  <button
                    @click="processInterest()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-green-400 py-3"
                  >
                   Yes, please continue
                  </button>
                  <button
                    @click="cancel()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-red-400 py-2"
                  >
                    Cancel
                  </button>
                </div>
          
        </template>
      </ModalSlide>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

const ModalSlide = () => import("@/components/ModalSlide.vue");

export default {
  name: "Boing",
  computed: {
        ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
        hasBoingAccess() {
      return this.currentAccess.boingAccess;
    },
        typeTitle() {
      return this.selectedType === 'login' ? "Signup to Boing Kids" : "Register my interest"
    }
  },
  data() {
    return {
      stages: [],
            registerComplete: false,
      showBoard: false,
      selectedType: null,
      contactName: "",
      contactEmail: "",
    };
  },
    mounted() {
      this.stages = [
        { id: 1, title: "PlayTank Stage 1", image: "stage1", key: "stage1"  },
        { id: 2, title: "PlayTank Stage 2", image: "stage2", key: "stage2" },
        {id: 3, title: "PlayTank Stage 3", image: "stage3", key: "stage3"},
      ];
  },
  methods: {
    contentImage(item) {
      return require("@/assets/images/boing/" + item.image + ".png");
    },
    showContent(item) {
      this.$router.push({
        name: "BoingContent",
        params: { object: item },
      });
    },
        completion() {
      this.registerComplete = true;
      this.selectedType = null 
      this.showBoard = false
    },
    registerInterest() {
      this.selectedType = "interest"
      this.showBoard = true
    },
    registerSignUp() {
      this.selectedType = "signup"
      this.showBoard = true
    },
    processInterest() {
      let result =  "Boing Kids \nType: " + this.selectedType + "\nContact: " + this.contactName + "\nEmail: " + this.contactEmail
      let payload = { content: result };
      SchoolService.create("comms/feature-request", payload)
        .then((response) => this.completion())
        .catch((err) => {
          this.cancel();
          console.log("Reset error " + err);
        });
    },
    cancel() {
      this.selectedType = null 
      this.showBoard = false
    }
  },
    components: {
    ModalSlide
  },
};
</script>
<style scoped>
</style>
